import PublicPurchaseMotionButton from 'pricing-pages-ui/features/purchaseMotions/components/PublicPurchaseMotionButton';
import { useAppSelector } from '../../../reducers';
import { planBuilderCheckoutProductConfigurationsSelector, planBuilderPaymentTermForProductsSelector } from '../../../selectors/PlanBuilderSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const PlanBuilderCTA = ({
  purchaseMotion,
  onClick,
  hubsSignupProductOverride,
  trackingSource,
  sourceId = 'pricing-middle',
  use = 'primary',
  block,
  children
}) => {
  const checkoutProductConfigurations = useAppSelector(planBuilderCheckoutProductConfigurationsSelector);
  const paymentTerm = useAppSelector(planBuilderPaymentTermForProductsSelector);
  return /*#__PURE__*/_jsx(PublicPurchaseMotionButton, {
    onClick: onClick,
    trackingSource: trackingSource,
    use: use,
    block: block,
    sourceId: sourceId,
    productConfigurations: checkoutProductConfigurations,
    dtbSource: `pricing-page|${trackingSource}`,
    hubsSignupProductOverride: hubsSignupProductOverride,
    purchaseMotion: purchaseMotion,
    queryParamTerm: paymentTerm,
    children: children
  });
};
export default PlanBuilderCTA;